{
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {},
      "geometry": {
        "coordinates": [
          [
            [
              -181.6879257778749,
              -15.363164865839337
            ],
            [
              -184.19761725061102,
              -17.99254637940085
            ],
            [
              -180.8463076877611,
              -21.003815974830715
            ],
            [
              -176.61472057113247,
              -18.588459717609013
            ],
            [
              -179.17084363399144,
              -15.08817942020535
            ],
            [
              -181.6879257778749,
              -15.363164865839337
            ]
          ]
        ],
        "type": "Polygon"
      }
    }
  ]
}